var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.25,
    height: 48.922,
    viewBox: "0 0 38.25 48.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SafeBoxes_Ikony_user",
    transform: "translate(-30.87 -25.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M50,46.68A10.57,10.57,0,1,1,60.57,36.11,10.58,10.58,0,0,1,50,46.68Zm0-17.11a6.54,6.54,0,1,0,6.54,6.54A6.549,6.549,0,0,0,50,29.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M34.91,74.46l1.44-16.32a4.405,4.405,0,0,1,4.41-4.04H59.23a4.405,4.405,0,0,1,4.41,4.04l1.44,16.32h4.04L67.65,57.79a8.407,8.407,0,0,0-8.42-7.71H40.76a8.407,8.407,0,0,0-8.42,7.71L30.87,74.46Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1348",
    "data-name": "Rectangle 1348",
    width: 4.02,
    height: 14.32,
    transform: "translate(55.92 60.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1349",
    "data-name": "Rectangle 1349",
    width: 4.02,
    height: 14.32,
    transform: "translate(40.06 60.14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8b389bcd0d1705103e375ac214a6ee8c.svg";
export { ForwardRef as ReactComponent };